<template>
    <div>
        <ol class="flex items-center">
            <li v-for="(step, stepIdx) in steps" :key="step.number" class="relative transition duration-300"
                :class="{'pr-8 sm:pr-20 w-full' : stepIdx !== steps.length - 1}">
                <!-- Completed Step -->
                <template v-if="step.status === 'complete'">
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="h-0.5 w-full" :class="'bg-' + stepBackgroundColour"/>
                    </div>
                    <a class="relative w-8 h-8 flex items-center justify-center rounded-full" :class="'bg-' + stepBackgroundColour" aria-hidden="true">
                        <icon-check class="w-5 h-5 text-white"/>
                    </a>
                </template>
                <!-- Current Step -->
                <template v-else-if="step.status === 'current'">
                    <div class="absolute inset-0 flex items-center">
                        <div class="h-0.5 w-full bg-gray-200"/>
                    </div>
                    <a class="relative w-8 h-8 flex items-center justify-center bg-white border-2 rounded-full" :class="'border-' + stepBackgroundColour">
                        <span class="h-2.5 w-2.5 rounded-full" :class="'bg-' + stepBackgroundColour" aria-hidden="true"/>
                    </a>
                </template>
                <!-- To Be Seen Step -->
                <template v-else>
                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                        <div class="h-0.5 w-full bg-gray-200"/>
                    </div>
                    <a class="group relative w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                        <span class="h-2.5 w-2.5 bg-transparent rounded-full" aria-hidden="true"/>
                    </a>
                </template>
            </li>
        </ol>
    </div>
</template>

<script>
export default {
    name: "SimpleSteps",

    props: {
        totalSteps: {
            required: true,
            type: Number,
        },
        currentStep: {
            required: true,
            type: Number,
        },
        stepBackgroundColour: {
            required: false,
            type: String,
            default: "indigo-600"
        },
    },

    data () {
        return {
            steps: [{status: "current", number: 1}],
        };
    },

    mounted () {
        this.calculateSteps(1);
    },

    watch: {
        currentStep (val) {
            //get index of previous step; val is new step
            this.calculateSteps(val);
        },
    },

    methods: {
        calculateSteps (val) {
            if (this.steps && this.steps.length > 1) {
                // Index of selected step
                let index = this.steps.indexOf(this.steps.filter(step => step.number === val)[0]);

                // Set all steps before to complete, after to incomplete
                for (let i = 0; i < this.steps.length; i++) {
                    if (i < index) {
                        this.$set(this.steps[i], "status", "complete");
                    } else if (i > index) {
                        this.$set(this.steps[i], "status", "incomplete");
                    } else {
                        this.$set(this.steps[index], "status", "current");
                    }
                }
            } else {
                // Setup steps if we dont have yet; Start at 2 because in data we declare the first step as current
                for (let i = 2; i <= this.totalSteps; i++) {
                    this.steps.push({status: "incomplete", number: i});
                }
            }
        }
    },
};
</script>

<style scoped>

</style>